import { assortmentSlice } from "./assortmentSlice";
import * as actions from "./assortmentActions";
import * as selectors from "./assortmentSelectors";

export { actions };
export { selectors };
export default assortmentSlice.reducer;
